import { defineStore } from "pinia";
import { ref } from "vue";
import { TruelayerCreatePaymentResponse } from "@/helpers/interfaces/providers";

/**
 * Truelayer store to manage Truelayer payment-related data such as payment information.
 * The store persists data in sessionStorage to maintain state across page
 * reloads within the same session.
 */
export const useTruelayerStore = defineStore(
    "truelayer",
    () => {
        // ── State ──────────────────────────────────────────────────────────────
        const truelayerPaymentInformation =
            ref<TruelayerCreatePaymentResponse | null>(null);

        // ── Actions ────────────────────────────────────────────────────────────
        function setTruelayerPaymentInformation(
            information: TruelayerCreatePaymentResponse | null,
        ) {
            truelayerPaymentInformation.value = information;
        }

        return {
            truelayerPaymentInformation,
            setTruelayerPaymentInformation,
        };
    },
    {
        persist: {
            pick: ["truelayerPaymentInformation"],
            storage: sessionStorage,
        },
    },
);
